import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/brentvatne/coding/react-native-action-sheet/src/ActionSheetProvider.tsx";
import * as React from 'react';
import ActionSheet from './ActionSheet';
import { Provider } from './context';

var ActionSheetProvider = function (_React$Component) {
  _inherits(ActionSheetProvider, _React$Component);

  function ActionSheetProvider(props) {
    var _this;

    _classCallCheck(this, ActionSheetProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionSheetProvider).call(this, props));

    _this.getContext = function () {
      return {
        showActionSheetWithOptions: function showActionSheetWithOptions(options, callback) {
          _this._actionSheetRef.current !== null && _this._actionSheetRef.current.showActionSheetWithOptions(options, callback);
        }
      };
    };

    _this._actionSheetRef = React.createRef();
    return _this;
  }

  _createClass(ActionSheetProvider, [{
    key: "render",
    value: function render() {
      return React.createElement(Provider, {
        value: this.getContext(),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        }
      }, React.createElement(ActionSheet, {
        ref: this._actionSheetRef,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        }
      }, React.Children.only(this.props.children)));
    }
  }]);

  return ActionSheetProvider;
}(React.Component);

export { ActionSheetProvider as default };